import { useContext, useState } from 'react';
import { deleteRequest as deleteHttpRequest } from './Api';
import * as Toast from './Toast.js';
import { ErrorContext } from './ErrorContext';
import type { APIErrorResponse, ApiOptions } from './Types';
import { AxiosError } from 'axios';

export default function (route: string, opts?: ApiOptions) {
    const [isDeleting, setIsDeleting] = useState(false);
    let res = null;
    const { errors, setErrors } = (res = useContext(ErrorContext));
    function deleteRequest(id: number) {
        if (isDeleting) {
            return Promise.resolve(null);
        }

        setIsDeleting(true);
        if (setErrors) setErrors(null); // Reset if we're posting again
        return deleteHttpRequest(`${route}/${id}`)
            .catch((err: AxiosError<APIErrorResponse>) => {
                const message = err.response?.data?.message;
                if (!opts?.noToast) {
                    if (message) {
                        Toast.error(message);
                    } else {
                        Toast.error('Failed to delete, please try again');
                    }
                }

                if (err.response?.data?.errors) {
                    if (setErrors) setErrors(err.response?.data?.errors);
                }

                throw err;
            })
            .finally(() => {
                setIsDeleting(false);
            });
    }

    return {
        isDeleting,
        deleteRequest,
    };
}
